import React from 'react';
import Modal from '@material-ui/core/Modal';
import { Theme, makeStyles } from '@material-ui/core';
import Label16 from './labels/Label16';
import RoundedCloseIcon from '../pages/signup/components/RoundedCloseIcon';

interface GivelifyModalProps {
    label: string;
    isOpen: boolean;
    children: React.ReactNode;
    width?: number;
    className?: string;
    disableBackdropClick?: true;
    disableClose?: true;
    handleClose: () => unknown;
}

export const useModalStyles = makeStyles((theme: Theme) => ({
    modalContent: {
        position: 'absolute',
        width: 690,
        padding: '48px 88px',
        backgroundColor: '#FDFEFF',
        boxShadow: theme.shadows[5],
        left: '50%',
        top: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        borderRadius: 10,
        textAlign: 'center',
        outline: 'none',
        '& button': {
            '& svg': {
                margin: 0,
            },
        },
        [`@media (max-width: 690px)`]: {
            width: '100%',
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            height: '100%',
            overflow: 'auto',
            position: 'fixed',
            top: 0,
            left: 0,
            transform: 'none',
        },
    },
    closeModal: {
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
    },
}));

const GivelifyModal: React.FC<GivelifyModalProps> = ({
    label,
    isOpen,
    handleClose,
    children,
    className,
    disableBackdropClick,
    disableClose,
}) => {
    const { modalContent, closeModal } = useModalStyles();
    return (
        <Modal
            aria-labelledby={label}
            open={isOpen}
            onClose={handleClose}
            className={className}
            disableBackdropClick={disableBackdropClick}
        >
            <div className={modalContent}>
                {!disableClose && (
                    <div className={closeModal} onClick={handleClose}>
                        <RoundedCloseIcon />
                    </div>
                )}
                <Label16 isBold>{label}</Label16>
                {children}
            </div>
        </Modal>
    );
};

export default GivelifyModal;
